import useEmblaCarousel from "embla-carousel-react"
import WheelGesturesPlugin from "embla-carousel-wheel-gestures"

export const useDatePartPicker = () => useEmblaCarousel(
    {
        axis: 'y',
        dragFree: true,
        containScroll: false,
        watchSlides: false,
        loop: true,
    },
    [
        WheelGesturesPlugin({ forceWheelAxis: 'y' })
    ]
)
